<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../app.config";
import Swal from "sweetalert2";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CheckModal from "@/components/CheckModal";
import EmployeeAPI from "@/services/employee/employeeAPI";
import CompanyAPI from "@/services/company/companyAPI";
import Table from "@/components/standard/PromotionPrevention/components/PromotionTable";
import { dateFormat } from "@/utils/helpers/format";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import procedimientosAPI from "../../../services/standards/procedimientos/procedimientosAPI";
import { sendNotification } from "@/utils/helpers/notification";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import ProcedimientosEvidencePagination from "../../../components/standard/procedimientos/ProcedimientosEvidencePagination.vue";

/**
 * Basic Tables component
 */
export default {
  page: {
    title: "4.2.3 Procedimientos, instructivos, fichas y protocolos",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    Table,
    CheckModal,
    ProcedimientosEvidencePagination,
  },
  data() {
    return {
      title: "4.2.3 Procedimientos, instructivos, fichas y protocolos",

      items: [
        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "4.2.3 Procedimientos, instructivos, fichas y protocolos",
          active: true,
        },
      ],
      list: [],
      usersList: [],

      item: null,

      itemData: null,
      search: "",
      deleteCount: 0,
      lista: [],
      loading: true,

      file: null,
      file2: null,

      lastId: 1,

      procedimiento: [],

      procedimientos: {
        document: null,
        evidence: null,
        procedures_and_protocols_id: this.$route.params.id,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      auditoria: {
        plan: null,
        report: null,
        business_audits_id: this.$route.params.id,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      submitted: false,

      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      nit: this.$store.getters["company/getCompany"].nit || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(9)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    deleteProcedimiento(id) {
      procedimientosAPI.deleteP(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 47,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se ha sido eliminado con éxito!",
                type: "success",
                icon: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    getItems() {
      try {
        CompanyItemsAPI.getStatus(this.companyID, 9)
          .then((response) => {
            this.item = response || null;
          })
          .catch((error) => {
            this.item = null;
            console.log(error);
          });
      } catch (error) {
        this.item = null;
        console.log(error);
      }
    },

    fetch() {
      this.$refs.paginator.query();
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/4.2.3/${this.$route.params.id}/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/4.2.3/${this.$route.params.id}/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.procedimientos.document = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    async uploadDocument2() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/4.2.3/${this.$route.params.id}/${this.lastId}/${this.file2.name}`;
        } else {
          url = `sst-prod/${this.nit}/4.2.3/${this.$route.params.id}/${this.lastId}/${this.file2.name}`;
        }
        const result = await uploadDocument(url, this.file2);
        if (result) {
          this.procedimientos.evidence = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesPromocion(response.id).then((res) => {
            this.usersList = res.employee;
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getShow() {
      procedimientosAPI
        .getShowP(this.$route.params.id)
        .then((response) => {
          this.procedimiento = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      procedimientosAPI
        .getAllE(this.$store.getters["company/getCompany"].id || null, this.$route.params.id)
        .then((response) => {
          this.lista = response.data.data;
          if (response.data.evidence_id) {
            this.lastId = this.lastId + 1
          }
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    goBack() {
      this.$router.go(-1);
    },

    async save() {
      this.submitted = true;
      this.loading = true;
      let response1 = await this.uploadDocument();
      let response2 = await this.uploadDocument2();
      if (response1 && response2) {
        procedimientosAPI
          .saveEvidencia(this.procedimientos)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 47,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.sendNotification(26, 9, true);
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    type: "success",
                    icon: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 2000);
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido registrar, error en los documentos!",
            type: "warning",
            icon: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },
  },
  mounted() {
    this.getList();
    this.getItems();
    this.getItemData();
    this.getUsers();
    this.getShow();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-lg-12">

        <div v-if="!loading">
          <div class="card">
            <div class="card-body">
              <form class="form-group px-2" @submit.prevent="save">
                <div class="row px-2">
                  <div class="col-12 text-right m-b-0">
                    <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                      <i class="fas fa-arrow-left"></i>
                    </div>
                    <b-tooltip target="back" placement="left">
                      Volver
                    </b-tooltip>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 col-sm-12">
                    <CheckModal>
                      <p class="text-justify">
                        La empresa debe contar con procedimientos, instructivos
                        y fichas técnicas de seguridad y salud en el trabajo,
                        para controlar los posibles accidentes derivados de la
                        realización de actividades o tareas peligrosas.
                      </p>
                      <p class="text-justify">
                        En este ítem la empresa podrá descargar los diferentes
                        programas, procedimientos y estándares de seguridad, los
                        cuales pueden ser adaptados e implementados en la
                        empresa.
                      </p>
                      <p class="text-justify">
                        Estos documentos deben ser entregados a los
                        colaboradores, garantizando su conocimiento y
                        aplicación.
                      </p>
                    </CheckModal>
                  </div>

                </div>

                <hr />
                <div class="form-row">
                  <h5 class="col-md-6 px-2">{{ this.procedimiento.risk_name }}</h5>
                  <h5 class="col-md-6 px-2">{{ this.procedimiento.standard_name }}</h5>
                </div>
                <div class="form-row pt-3">
                  <b-form-group class="col-md-6 px-2" label="Subir documento" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Subir evidencia de socialización" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file2" ref="file2"
                      name="file2" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file2" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0 pt-2">
                  <button type="submit" :disabled="submitted" class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="reset" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr v-if="getRole('Consultar')" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <form @submit.prevent="fetch()" class="form-inline">
                            <div class="form-group mr-2">
                              <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                class="form-control px-2" placeholder="Buscar"></b-form-input>

                              <div class="col-1">
                                <button type="submit" class="btn btn-primary px-2">
                                  Buscar
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                          <thead>
                            <tr>
                              <th class="text-center align-middle">Fecha subida del archivo</th>

                              <th class="text-center align-middle">
                                Ver documento
                              </th>
                              <th class="text-center align-middle">
                                Evidencia de socialización
                              </th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.evidence_id">
                              <td class="text-center align-middle">
                                {{ dateConvert(dato.created_at_evidence) }}
                              </td>
                              <td class="text-center align-middle">
                                <div v-if="dato.document === null">
                                  <h6>No hay archivo disponible</h6>
                                </div>
                                <div v-else>
                                  <button :disabled="!allowAccess()" style="
                                        background-color: transparent !important;
                                        border: none;
                                      " type="button" @click="
                                        gotoDigitalOcean(`${dato.document}`)
                                        ">
                                    <i class="mdi mdi-cloud-download"></i>
                                  </button>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div v-if="dato.evidence === null">
                                  <h6>No hay archivo disponible</h6>
                                </div>
                                <div v-else>
                                  <button :disabled="!allowAccess()" style="
                                        background-color: transparent !important;
                                        border: none;
                                      " type="button" @click="
                                        gotoDigitalOcean(`${dato.evidence}`)
                                        ">
                                    <i class="mdi mdi-cloud-download"></i>
                                  </button>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                      " v-b-modal="`modal${dato.evidence_id}`">Editar</b-dropdown-item>

                                    <b-modal :id="`modal${dato.evidence_id}`" body-class="p-4" hide-header hide-footer
                                      size="sm">
                                      <div class="text-justify">
                                        <h4 class="mt-2 text-primary text-center">
                                          Advertencia
                                        </h4>
                                        <p class="mt-3">
                                          Al modificar esta información se
                                          quitará el puntaje correspondiente a
                                          este ítem y será necesario realizar
                                          nuevamente la validación por parte del
                                          usuario responsable de Emisión.
                                        </p>
                                        <button :disabled="!getRole('Editar') || !allowAccess()
                                          " type="button" class="btn btn-primary my-2 mx-2">
                                          <router-link class="text-white" :to="{
                                            path: `/forms/estandares/procedimientos-evidencia-editar/${dato.evidence_id}`,
                                          }">Editar
                                          </router-link>
                                        </button>
                                        <button type="button" @click="
                                          $bvModal.hide(`modal${dato.evidence_id}`)
                                          " class="btn btn-danger btn mx-2" data-dismiss="modal">
                                          Cancelar
                                        </button>
                                      </div>
                                    </b-modal>
                                    <b-dropdown-item :disabled="!allowAccess() || !getRole('Editar')
                                      " :to="{
                                        path: `/forms/estandares/procedimientos-evidencia-ver/${dato.id}`,
                                      }">
                                      Ver
                                    </b-dropdown-item>

                                    <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                      " v-on:click="
                                        deleteProcedimiento(dato.evidence_id)
                                        ">Eliminar</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <ProcedimientosEvidencePagination ref="paginator" :search="search"
                          @fetch="(items) => (lista = items)" />
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
        <!-- end card -->
      </div>
    </div>
    <!--- end row -->
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
